import { LOCATION_CHANGE } from 'connected-react-router'
import createReducer from './utilities/createReducer'
import appReducer from './appReducer'
import brandReducer from './brandReducer'
import itemReducer from './itemReducer'
import fetchReducer from './fetchReducer'
import feedReducer from './feedReducer'
import voteReducer from './voteReducer'
import authReducer from './authReducer'
import kitReducer from './kitReducer'
import notificationReducer from './notificationReducer'
import postReducer from './postReducer'
import commentReducer from './commentReducer'
import searchReducer from './searchReducer'
import userProfilePublicReducer from './userProfilePublicReducer'
import userProfileReducer from './userProfileReducer'

//	Note: Each reducer can also set their initial states, but
//	we want to define it here, so you get a global view of the state object

const initialState = {
	user: {
		isLoading: true // this will be overwritten by auth
	}
}

const newLocationState = {
	backButtonFunction: true,
	backgroundImage: false,
	backgroundWhite: false,
	nextButtonIsLoading: false,
	bottomNavBarHandleClick: () => {},
	bottomNavBarLabelNext: '',
	bottomNavBarValue: {},
	bottomBarValue: undefined,
	drawerOpen: false,
	heading: { text: null },
	contextMenus: [],
	message: false,
	messageType: false,
	pageHasLoaded: false,
	showBottomBar: true,
	showBottomNavBar: false,
	showSnackbar: false,
	showTopBar: true
}

//	Any global/non-redux things are defined here
const rootReducer = createReducer(initialState, {
	//	Reset the app UI state when you navigate
	[LOCATION_CHANGE]: state => Object.assign({}, state, newLocationState)
})

//	Note: combineReducers doesn't do what we want, so do our own thing...
//	Ref: https://redux.js.org/recipes/structuring-reducers/beyond-combinereducers
//	Our pattern is to have stand-alone reducers mashed together
const mashReducers = (...rest) => (state, ...argRest) => {
	let newState = state
	try {
		rest.forEach((reduce) => {
			newState = reduce(newState, ...argRest)
		})
	} catch (ex) {
		console.error('REDUCER ERROR', ex)
		//	This is a fatal error, so we throw
		throw ex
	}
	return newState
}

export default mashReducers(rootReducer, appReducer, brandReducer, voteReducer, authReducer, itemReducer, fetchReducer, feedReducer, userProfileReducer, userProfilePublicReducer, searchReducer, notificationReducer, commentReducer, kitReducer, postReducer)



// WEBPACK FOOTER //
// ./src/redux/reducers/index.js